<template>
  <div class="p-d-flex p-flex-column p-ai-center p-jc-center p-pl-4 p-pr-4 p-text-center" style="height: 70vh; gap: 20px;">
    <!-- https://mia-app.it/checkout/success?session_id={CHECKOUT_SESSION_ID} -->
    <img src="assets/irinox/icons/payment_cancel.svg" width="200" alt="Checkout Cancel" class=""/>
    <h1>{{ $t('checkout.cancel.title') }}</h1>
    <div class="checkout-cancel-message">{{ $t('checkout.cancel.subtitle') }}</div>
    <div class="p-d-flex p-flex-column p-flex-md-row-reverse p-ai-center" style="gap: 30px; margin-top: 30px;">
      <Button class="p-mt-4" :label="$t('checkout.cancel.button_retry')" @click="$router.push('/admin?tab=invoices')"></Button>
      <Button class="p-mt-4" severity="secondary" :label="$t('checkout.cancel.button_plans')" @click="$router.push('/admin?tab=services')"></Button>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  setup() {
    // nessuna logica per ora
  },
  props: {
  },
  data() {
    return {
    };
  },
  computed: {
  },
  watch: {
  },
  created() {
  },
  mounted() {
  },
  methods: {
  },
}
</script>

<style scoped>
</style>